import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import DataStore from '../../support/DataStore';
import { viewAsSeason } from '../../support/Season';

import { Button, DropdownButton, Text } from '../uiold';

import { Account } from '../../types/shared/Account';
import { themeColors } from '../uiold/Constants';

type Props = RouteComponentProps & {
  account?: Account;
};

const dataStore = DataStore.getInstance('app');

class ViewingSeason extends Component<Props> {
  _subscription = dataStore.onChange('season', () => {
    this.forceUpdate();
  });

  componentWillUnmount() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  render() {
    let { account } = this.props;
    let season = dataStore.get('season');
    if (!account || !season) {
      return null;
    }
    let { name } = season;
    return (
      <View style={styles.root}>
        <Text style={styles.textLabel}>{t('Viewing:')}</Text>
        <View style={styles.buttonContainer}>
          <DropdownButton title={name} showCaret noBorder alignPickerRight>
            <Button
              onPress={this._goBackToCurrent}
              iconName="back"
              title={t('Back to Current Season')}
              style={styles.button}
              hoverStyle={styles.hoveredButton}
            />
          </DropdownButton>
        </View>
      </View>
    );
  }

  _goBackToCurrent = () => {
    viewAsSeason(null);
    this.props.history.push('/vendors');
  };
}

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    marginHorizontal: 2,
    height: 34,
  },
  textLabel: {
    lineHeight: 34,
    marginHorizontal: 4,
  },
  buttonContainer: {
    height: 34,
  },
  button: {
    marginHorizontal: 0,
  },
  hoveredButton: {
    backgroundColor: themeColors.grey,
  },
});

export default withRouter(ViewingSeason);
